module.exports = __webpack_public_path__ + "img/banner.0a4d77e.png";